import { Invoice } from './components/Invoice';

export const InvoicesRouteComponent = Invoice;
